import { FC } from 'react'
import VolumeOffRoundedIcon from '@mui/icons-material/VolumeOffRounded'
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded'

import { useFeedStore } from '../../store/feed-store'

interface SoundControlProps {
  visible: boolean
}

const SoundControl: FC<SoundControlProps> = ({ visible }) => {
  const { mute, toggleMute } = useFeedStore()

  if (!visible) {
    return null
  }

  return mute ? (
    <VolumeOffRoundedIcon sx={{ color: 'white' }} onClick={toggleMute} />
  ) : (
    <VolumeUpRoundedIcon sx={{ color: 'white' }} onClick={toggleMute} />
  )
}

export default SoundControl
